/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const AddressPrecision = {
    Exact: 'Exact',
    Street: 'Street',
    Intersection: 'Intersection',
    Suburb: 'Suburb',
    Approximate: 'Approximate'
};
export function AddressPrecisionFromJSON(json) {
    return AddressPrecisionFromJSONTyped(json, false);
}
export function AddressPrecisionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function AddressPrecisionToJSON(value) {
    return value;
}
